<template>
  <div class="article-card">
    <div class="article-card__title" ref="title">
      <router-link
        :to="articleThumb.url"
        tag="h5"
        class="text-uppercase is-pointer"
      >{{ articleThumb.contents[0].title }}</router-link>
    </div>
    <div class="article-card__thumbnail">
      <router-link :to="articleThumb.url">
        <img :src="articleThumb.contents[0].thumb">
      </router-link>
    </div>
    <div class="article-card__details">
      <p class="size-2 my-2 article-pdate">
        <i class="fas fa-calendar-alt"></i>
        {{ articleThumb.publishDate }}
      </p>
      <div
        class="article-card__description text-justify"
        ref="description"
      >{{ articleThumb.contents[0].description }}</div>
      <router-link
        :to="articleThumb.url"
        class="article-card__btn btn__chip my-2"
      >{{ getCaption("caption.read_more_button") }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["articleThumb"],

  mounted() {
    let docWidth = $(document).width();
    if (docWidth >= 960) {
      let titleHeight = $(this.$refs.title).height();
      let dateHeight = $(".article-pdate").outerHeight(true);
      let buttonHeight = $(".article-card__btn").outerHeight(true);

      let descriptionHeight = 162 - titleHeight - dateHeight - buttonHeight;
      $(this.$refs.description).height(descriptionHeight);
    }
  }
};
</script>


<style lang="scss" scoped>
.article-card {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto auto;
  grid-column-gap: 1em;
  margin: 1.5em 0;
  position: relative;
}

.article-card__title {
  grid-row-start: 1;
  grid-row-end: 2;
  h5 {
    margin: 0;
  }
}
.article-pdate {
  color: #777;
}

.article-card__thumbnail {
  grid-row-start: 2;
  grid-row-end: 3;
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 162px / 268px * 100%;
  background: white;
  position: relative;

  a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}

.article-card__details {
  grid-row-start: 3;
  grid-row-end: 4;
}

@media (min-width: $breakpoint-sm) {
  .article-card {
    grid-template-columns: 165px auto;
    grid-template-rows: auto auto;
    grid-column-gap: 1em;
    margin: 1.5em 1em 1.5em 0;
  }

  .article-card__title {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  .article-card__thumbnail {
    grid-column-start: 1;
    grid-column-end: 2;
  }

  .article-card__details {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 3;
  }
  .article-card .btn__chip {
    float: right;
    margin-right: 1.5em;
    background-color: #f89025;
    color: #fff !important;
  }
}
@media (min-width: $breakpoint-smd) {
  .article-card {
    grid-template-columns: 220px auto;
  }
}
@media (min-width: $breakpoint-md) {
  .article-card {
    grid-template-columns: 220px auto;
  }
}

@media (min-width: $breakpoint-lg) {
  .article-card {
    grid-template-columns: 268px auto;
    height: 162px;
    overflow: hidden;
    align-items: start;
  }

  .article-card__title {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
  }

  .article-card__thumbnail {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 3;
  }

  .article-card__details {
    height: 100%;
  }

  .article-card__description {
    line-height: 1.2;
    overflow: hidden;
  }

  .article-card__btn {
    display: inline-block;
  }
}

.article-card:first-child {
  margin-top: 0 !important;
}
</style>